module.exports = __webpack_public_path__ + "img/c7.08d40de3.jpg";